import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createContext, useContext, useEffect, useReducer, useCallback, memo } from "react";
import { useRouter } from "next/router";
import styles from "@/styles/Copyrights.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var CopyrightsContext = /*#__PURE__*/createContext({
  copyrights: [],
  setCopyrights: function setCopyrights() {
    return null;
  },
  resetCopyrights: function resetCopyrights() {
    return null;
  }
});
CopyrightsContext.displayName = "CopyrightsContext";
var initializeValue = [];

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "reset":
      return initializeValue;

    case "add":
      var newState = _toConsumableArray(new Set(state.concat(action.value)));

      return newState.filter(Boolean);

    default:
      return state;
  }
};

export function CopyrightsProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(reducer, initializeValue),
      copyrights = _useReducer[0],
      dispatch = _useReducer[1];

  var setCopyrights = useCallback(function (value) {
    dispatch({
      type: "add",
      value: value
    });
  }, []);
  var resetCopyrights = useCallback(function () {
    dispatch({
      type: "reset"
    });
  }, []);
  return /*#__PURE__*/_jsx(CopyrightsContext.Provider, {
    value: {
      copyrights: copyrights,
      setCopyrights: setCopyrights,
      resetCopyrights: resetCopyrights
    },
    children: children
  });
}

function Copyrights() {
  var router = useRouter();

  var _useContext = useContext(CopyrightsContext),
      copyrights = _useContext.copyrights,
      resetCopyrights = _useContext.resetCopyrights;

  useEffect(function () {
    var handleHistoryChange = function handleHistoryChange() {
      resetCopyrights();
    };

    router.events.on("routeChangeStart", handleHistoryChange);
    router.events.on("hashChangeStart", handleHistoryChange);
    return function () {
      router.events.off("routeChangeStart", handleHistoryChange);
      router.events.off("hashChangeStart", handleHistoryChange);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.copyrights,
    children: /*#__PURE__*/_jsx("p", {
      className: styles.list,
      children: copyrights.map(function (c, i) {
        return /*#__PURE__*/_jsx("span", {
          children: c
        }, "copyright-".concat(i));
      })
    })
  });
}

export default /*#__PURE__*/memo(Copyrights);